import { FriendListItemProps } from "../types"
import React from "react"
import { CheckBox } from "~widgets/check-box"
import { Swipeable } from "~widgets/swipeable"
import styled from '~/ui/styled'
import FriendListItemCore from "./friend-list-item-core"
import { BetweenFlex } from "~components/El"

const ItemRow = styled(BetweenFlex)`
  background-color: ${({ theme }) => theme.colors.blockBackground};
`

const CheckWrap = styled.div`
  padding-left: ${({ theme }) => theme.space.md};
`

const FriendListItem: React.FC<FriendListItemProps> = ({
  friend,
  swipeActionButtonConfigs,
  onItemClick,
  selecteds,
}) => {
  return (
    <Swipeable item={friend} actions={swipeActionButtonConfigs}>
      <ItemRow>
        {selecteds && (
          <CheckWrap>
            <CheckBox curValue={selecteds} value={friend.user.id} />
          </CheckWrap>
        )}
        <FriendListItemCore friend={friend} onAccept={() => onItemClick?.(friend, 'APPROVE')} onReject={() => onItemClick?.(friend, 'REJECT')}></FriendListItemCore>
      </ItemRow>
    </Swipeable>
  )
}

export default FriendListItem
